// removed by extract-text-webpack-plugin
module.exports = {"standardTable":"index__standardTable__3DIwF","tableAlert":"index__tableAlert__2woeW","selected":"index__selected__2KHrQ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/StandardTable/index.less
// module id = 1099
// module chunks = 0